var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.84088L5.1027 5.28277L3.42838 3.60845C4.94324 2.09358 7.49459 2.09358 9.00946 3.60845C9.80676 4.32601 10.2054 5.3625 10.2054 6.39899C10.2054 7.43547 9.80676 8.47196 9.00946 9.18953C7.49459 10.7044 4.94324 10.7044 3.42838 9.18953C2.95 8.71115 2.55135 8.07331 2.39189 7.35574L0.877027 7.83412C1.11622 8.79088 1.59459 9.66791 2.31216 10.3855C4.46486 12.5382 7.97297 12.5382 10.2054 10.3855C11.2419 9.34899 11.8 7.91385 11.8 6.47872C11.8 4.96385 11.2419 3.60845 10.2054 2.57196C8.0527 0.419258 4.54459 0.419258 2.31216 2.57196L0.558108 0.817907L0 5.84088Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.8b8b84cc.svg";
export { ForwardRef as ReactComponent };